import styled from 'styled-components'
import { margin, MarginProps } from 'styled-system'

import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

import { LANDING_CONTENT_WIDTH_PX } from 'Constants/Landing'

const shouldForwardProp = (prop: string) =>
  !DIV_SHOULD_FORWARD_PROP.includes(prop)

export const Container = styled.div.withConfig({
  shouldForwardProp,
})<MarginProps>`
  width: 100%;
  max-width: ${LANDING_CONTENT_WIDTH_PX}px;
  border-radius: 20px;
  overflow: hidden;

  > img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  ${margin}
`
